import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=813ee938"
import script from "./NotFound.js?vue&type=script&lang=js&external"
export * from "./NotFound.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports